export {
  BaseEventProps,
  GetGlobalProperties,
  GlobalProperties,
  GlobalPropertiesObject,
  LoginStatusValues,
  UserCustomProperties
} from "@tvg/amplitude/types";
export { init as trackingInit } from "./init";
export { getPageName, buildGlobalProperties } from "./utils";
export {
  default as amplitudeInit,
  setAmplitudeUserId,
  setAmplitudeUserProperties,
  setAmplitudeAnonymize,
  track
} from "./amplitude";
